import { Chip } from '@offerzen/pinata'
import React from 'react'
import { cx } from '@emotion/css'
import Image from 'next/image'
import PropTypes from 'prop-types'
import PreferredLocations from '../PreferredLocations'
import styles from './styles'

const ProfileOverview = ({ isNewCandidate, roleName, preferredCities, profilePicture, salary }) => {
  return (
    <div className={styles.profile}>
      <div className={styles.roleFlexContainer}>
        <Image
          src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/profiles/${profilePicture}`}
          alt="Candidate profile image"
          className={styles.avatar}
          width={65}
          height={65}
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
        <h3 className={cx(styles.title, styles.mobileTitle)}>{roleName}</h3>
      </div>
      <div className={styles.detailsFlexContainer}>
        <h3 className={cx(styles.title, styles.desktopTitle)}>{roleName}</h3>
        <div className={cx(styles.subText, styles.details)}>
          <div className={styles.subText}>
            Prefers <span className={styles.boldText}>{salary}</span>
          </div>
          <PreferredLocations preferredCities={preferredCities} className={styles.subText} />
        </div>
      </div>

      {isNewCandidate && <Chip label="New this week" className={styles.desktopChip} size="small" theme="success" />}
    </div>
  )
}

ProfileOverview.propTypes = {
  isNewCandidate: PropTypes.bool,
  profilePicture: PropTypes.string,
  roleName: PropTypes.string,
  preferredCities: PropTypes.arrayOf(PropTypes.string),
  salary: PropTypes.string,
}

export default ProfileOverview
